export class Item {
    public object: Phaser.GameObjects.Image;
    public name: string;
    public rect: Phaser.Geom.Rectangle;
    public follow: boolean;
    public itemTexture: string;
    public itemFrame: string;
    public startPosition: Phaser.Math.Vector2;
    public dropped: boolean;
   
    constructor(object: Phaser.GameObjects.Image, name: string, rect: Phaser.Geom.Rectangle, follow: boolean, itemTexture: string, itemFrame: string) {
        this.object = object;
        this.name = name;
        this.rect = rect;
        this.follow = follow;
        this.itemTexture = itemTexture;
        this.itemFrame = itemFrame;
        this.startPosition = new Phaser.Math.Vector2(object.x, object.y);
        this.dropped = false;
    }
}



// WEBPACK FOOTER //
// ./src/games/LandscapingGame/objects/Item.ts